import PropTypes from "prop-types"
import { Suspense } from "react"

const Segment = ({ name, segment }) => {
  const digits = segment.split("")

  return digits.map((digit, i) => (
    <div
      className="flex w-9 justify-center align-baseline font-bold"
      key={`${name}_${digit}_${i}`}
    >
      {typeof window !== "undefined" && (
        <Suspense fallback={<div />}>
          <span>{digit}</span>
        </Suspense>
      )}
    </div>
  ))
}

Segment.propTypes = {
  name: PropTypes.string,
  segment: PropTypes.string,
}

export default Segment
